/**
 * Utilitaire pour gérer l'authentification
 */

// Récupérer l'utilisateur actuel depuis le localStorage
export const getCurrentUser = () => {
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  } catch (error) {
    console.error('Erreur lors de la récupération des données utilisateur:', error);
    return null;
  }
};

// Récupérer l'ID de l'utilisateur actuel ou un ID par défaut
export const getUserId = () => {
  const user = getCurrentUser();
  // ID par défaut à utiliser si l'utilisateur n'est pas connecté
  return user?._id || '64a7e1e4e0e5cb001c3d3f2a';
};

// Vérifier si l'utilisateur est authentifié
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  const user = getCurrentUser();
  return !!token && !!user;
};